/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_glasses': {
    width: 16,
    height: 16,
    viewBox: '0 0 26 15.195',
    data: '<path pid="0" d="M25.978 9.082a1.163 1.163 0 00.015-.18c0-3.679-1.3-6.131-3.965-7.495C19.607.169 16.258-.001 13-.001S6.392.17 3.972 1.407C1.3 2.772.006 5.224.006 8.903a1.156 1.156 0 00.015.18.61.61 0 00-.021.159v2.916a.7.7 0 00.505.661l1.859.506a5.851 5.851 0 004.45 1.871 5.612 5.612 0 004.837-2.406h2.7a5.612 5.612 0 004.837 2.406 5.851 5.851 0 004.45-1.871l1.859-.506a.7.7 0 00.505-.661V9.242a.613.613 0 00-.024-.16zM13 2.316c6.99 0 10.44.921 10.666 6.034l-.371-.054a6.013 6.013 0 00-4.108-1.513 5.612 5.612 0 00-4.837 2.406h-2.7a5.612 5.612 0 00-4.837-2.407 6.013 6.013 0 00-4.108 1.513l-.371.054C2.56 3.236 6.01 2.316 13 2.316z" _fill="#00b3d3"/>'
  }
})
